<template>
  <div class="users-table">
    <v-card>
      <v-data-table
        :headers="headers"
        :items="data ? data : []"
        :search="search"
        :loading="isLoading"
      >
        <template v-slot:item.last_name="{ item }">
          <span v-if="item.last_name && item.last_name.trim()">{{ item.last_name }}</span>
          <v-chip v-else color="warning" small>Missing</v-chip>
        </template>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-btn icon small color="primary" class="ma-2" @click="$emit('refresh')">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </template>
        <!-- <template v-slot:item.actions="{ item }">
          <v-icon color="error" @click="$emit('deleteOne', item)">mdi-delete</v-icon>
        </template>-->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, required: true },
    headers: { type: Array, required: true },
    isLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      search: ""
    };
  }
};
</script>
